<template>
  <Cfg>
    <slot>
      <div class="animated fadeIn">
        <Alerts ref="alert" />
        <Forms ref="frmGroup" :title="this.$lang.Expert.TitleForm" :showHelp="true" :showClearButton="true"
          :showSaveButton="true" v-on:Clear="onClear" v-on:Save="onSave">
          <div class="form-group row">
            <div class="col-md-6">
              <label for="txtExpertName"><small class="text-danger">*</small>
                {{ $lang.Expert.LabelName }}:</label>
              <div class="input-group">
                <b-form-input type="text" name="txtExpertName" :placeholder="$lang.Expert.PlaceholderEnterName"
                  v-model="form.name.value" :maxlength="form.name.maxlength" :required="form.name.required"
                  :state="form.name.state"></b-form-input>
              </div>
            </div>
            <div class="col-md-6">
              <label for="txtExpertName"><small class="text-danger">*</small>
                {{ $lang.Expert.LabelCPF }}:</label>
              <div class="input-group">
                <b-form-input type="text" name="txtExpertName" :placeholder="$lang.Expert.PlaceholderEnterCPF"
                  v-model="form.cpf.value" :maxlength="form.cpf.maxlength" :required="form.cpf.required"
                  :state="form.cpf.state" v-mask="['###.###.###-##']" @blur.native="onCheckCPF"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-6">
              <label for="txtEmail"><small v-show="form.email.required" class="text-danger">*</small>
                {{ $lang.Expert.LabelEmail }}:</label>
              <div class="input-group">
                <b-form-input type="text" id="txtEmail" name="txtEmail"
                  :placeholder="$lang.Expert.PlaceholderEnterEmail" v-model="form.email.value"
                  :maxlength="form.email.maxlength" :required="form.email.required" autocomplete="off"
                  :state="form.email.state"></b-form-input>
              </div>
            </div>
            <div class="col-md-6">
              <label for="txtCellPhone"><small v-show="form.cellPhone.required" class="text-danger">*</small>
                {{ $lang.Expert.LabelCellphone }}:</label>
              <div class="input-group">
                <b-form-input type="text" name="txtCellPhone" :placeholder="$lang.Common.MobilePhonePlaceholder"
                  v-model="form.cellPhone.value" :maxlength="form.cellPhone.maxlength"
                  :required="form.cellPhone.required" :state="form.cellPhone.state" autocomplete="off"
                  v-mask="['(##) ####-####', '(##) # ####-####']"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-2">
              <label for="cbxCountry"><small class="text-danger">*</small>
                {{ $lang.Expert.LabelCoutry }}:</label>
              <div class="input-group">
                <select class="mb-3 form-control custom-select" disabled>
                  <option value="2375E209-7451-4A7A-A9BE-66BD2C392BE1" selected>
                    BRASIL
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <label for="cbxState"><small v-show="form.stateID.required" class="text-danger">*</small>
                {{ $lang.Expert.LabelState }}:</label>
              <div class="input-group">
                <b-form-select v-model="form.stateID.value" :options="form.stateID.options" :state="form.stateID.state"
                  class="mb-3" name="cbxState" @change="onChangeState">
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">
                      {{ $lang.Common.PlaceholderSelect }}
                    </option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-6">
              <label for="cbxCity"><small v-show="form.cityID.required" class="text-danger">*</small>
                {{ $lang.Expert.LabelCity }}:</label>
              <div class="input-group">
                <b-form-select v-model="form.cityID.value" :options="form.cityID.options" :state="form.cityID.state"
                  class="mb-3" name="cbxCity">
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">
                      {{ $lang.Common.PlaceholderSelect }}
                    </option>
                  </template>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12 pt-4">
              <h5 class="text-third">
                <i class="fa fa-map-signs"></i> Local de atuação
              </h5>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-6">
              <label for="cbxArea"><small v-show="form.areaID.required" class="text-danger">*</small>
                {{ $lang.Expert.LabelArea }}:</label>
              <div class="input-group">
                <b-form-select v-model="form.areaID.value" :options="form.areaID.options" :state="form.areaID.state"
                  class="mb-3" name="cbxArea" @change="onChangeArea">
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">
                      {{ $lang.Common.PlaceholderSelect }}
                    </option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-6">
              <label for="cbxRegionService"><small v-show="form.regionServiceID.required" class="text-danger">*</small>
                {{ $lang.Expert.LabelRegionService }}:</label>
              <div class="input-group">
                <b-form-select v-model="form.regionServiceID.value" :options="form.regionServiceID.options"
                  :state="form.regionServiceID.state" class="mb-3" name="cbxRegionService">
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">
                      {{ $lang.Common.PlaceholderSelect }}
                    </option>
                  </template>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12 pt-4">
              <h5 class="text-third">
                <i class="fa fa-suitcase"></i> Especializações
              </h5>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-6">
              <label for="cbxBudgetSystem"><small v-show="form.budgetSystemList.required" class="text-danger">*</small>
                {{ $lang.Expert.LabelBudgetSystem }}:</label>
              <div class="input-group">
                <v-select style="width: 100%" multiple v-model="form.budgetSystemList.value"
                  :options="form.budgetSystemList.options">
                </v-select>
              </div>
            </div>
            <div class="col-md-3">
              <label for="cbxSinisterType"><small v-show="form.regulationTypeList.required"
                  class="text-danger">*</small>
                {{ $lang.Expert.LabelSinisterType }}:</label>
              <div class="input-group">
                <v-select style="width: 100%" multiple v-model="form.regulationTypeList.value"
                  :options="form.regulationTypeList.options">
                </v-select>
              </div>
            </div>
            <div class="col-md-3">
              <label for="cbxSchedulingType"><small v-show="form.schedulingTypeList.required"
                  class="text-danger">*</small>
                {{ $lang.Expert.LabelSchedulingTypes }}:</label>
              <div class="input-group">
                <v-select style="width: 100%" multiple v-model="form.schedulingTypeList.value"
                  :options="form.schedulingTypeList.options" />
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-6">
              <label for="cbxInsuranceCompany"><small v-show="form.insuranceList.required" class="text-danger">*</small>
                {{ $lang.Expert.LabelInsuranceCompany }}:</label>
              <div class="input-group">
                <v-select style="width: 100%" multiple v-model="form.insuranceList.value"
                  :options="form.insuranceList.options" @input="onChangeInsurance" />
              </div>
            </div>
            <div class="col-md-6">
              <label for="cbxInsuranceCompany"><small v-show="form.insuranceList.required" class="text-danger">*</small>
                {{ $lang.Expert.LabelBusinessType }}:</label>
              <div class="input-group">
                <v-select style="width: 100%" multiple v-model="form.businessTypeList.value"
                  :options="form.businessTypeList.options" />
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12 pt-4">
              <h5 class="text-third">
                <i class="fa fa-info-circle"></i> Informações complementares
              </h5>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-6">
              <label for="cbxAdditionalExpenses"><small v-show="form.additionalExpenses.required" class="text-danger">*</small>{{
                  $lang.Expert.LabelAdditionalExpenses
              }}</label>
              <div class="input-group">
                <b-form-select v-model="form.additionalExpenses.value" :options="form.additionalExpenses.options"
                  :state="form.additionalExpenses.state" class="mb-3" name="cbxAdditionalExpenses"
                  >
                  <template slot="first">
                    <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
                  </template>
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-6">
              <label for="cbxIncludeKM"><small v-show="form.includeKM.required" class="text-danger">*</small>{{
                  $lang.Expert.LabelIncludeKM
              }}</label>
              <div class="input-group">
                <b-form-select v-model="form.includeKM.value" :options="form.includeKM.options"
                  :state="form.includeKM.state" class="mb-3" name="cbxIncludeKM">
                  <template slot="first">
                    <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
                  </template>
                  <option :value="true">Sim</option>
                  <option :value="false">Não</option>
                </b-form-select>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12 pt-4">
              <h5 class="text-third">
                <i class="fa fa-bank"></i> Dados bancário
              </h5>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-3">
              <label for="cbxBank"><small v-show="form.bankID.required" class="text-danger">*</small>
                {{ $lang.Expert.LabelBank }}:</label>
              <div class="input-group">
                <b-form-select v-model="form.bankID.value" :options="form.bankID.options" :state="form.bankID.state"
                  class="mb-3" name="cbxBank">
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option :value="null">
                      {{ $lang.Common.PlaceholderSelect }}
                    </option>
                  </template>
                </b-form-select>
              </div>
            </div>
            <div class="col-md-3">
              <label for="txtLabelAgency"><small v-show="form.agency.required" class="text-danger">*</small>
                {{ $lang.Expert.LabelAgency }}:</label>
              <div class="input-group">
                <b-form-input type="text" name="txtLabelAgency" :placeholder="$lang.Expert.PlaceholderEnterAgency"
                  v-model="form.agency.value" :maxlength="form.agency.maxlength" :required="form.agency.required"
                  autocomplete="off" :state="form.agency.state"></b-form-input>
              </div>
            </div>
            <div class="col-md-3">
              <label for="txtLabelAccountBank"><small v-show="form.accountBank.required" class="text-danger">*</small>
                {{ $lang.Expert.LabelAccountBank }}:</label>
              <div class="input-group">
                <b-form-input type="text" name="txtLabelAccountBank"
                  :placeholder="$lang.Expert.PlaceholderEnterAccountBank"
                  v-model="form.accountBank.value"
                  :maxlength="form.accountBank.maxlength"
                  :required="form.accountBank.required" autocomplete="off"
                  :state="form.accountBank.state"></b-form-input>
              </div>
            </div>
            <div class="col-md-3">
              <label for="txtPix"><small v-show="form.pix.required" class="text-danger">*</small>
                {{ $lang.Expert.LabelPix }}:</label>
              <div class="input-group">
                <b-form-input type="text" name="txtPix"
                  :placeholder="$lang.Expert.PlaceholderEnterPix"
                  v-model="form.pix.value"
                  :maxlength="form.pix.maxlength"
                  :required="form.pix.required"
                  autocomplete="off"
                  :state="form.pix.state"></b-form-input>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtDescription">
                {{ $lang.Expert.LabelDescription }}:</label>
              <b-form-textarea id="txtDescription" name="txtDescription" v-model="form.description.value"
                :placeholder="$lang.Expert.PlaceholderEnterDescription" :rows="form.description.rows"
                :maxlength="form.description.maxlength" :noResize="form.description.noResize"></b-form-textarea>
              <small class="small-help"><i class="fa fa-info-circle"></i>
                <span v-html="FieldSizeTip"></span>.</small>
            </div>
          </div>
        </Forms>

        <Forms ref="frmSearch" :title="$lang.Expert.Search" :showHelp="false" :showSearchButton="true"
          :showClearButton="false" :showSaveButton="false" @Search="onSearch">
          <div class="form-group row">
            <div class="col-md-12">
              <label for="txtExpertSearchName"><small class="text-danger">*</small>
                {{ $lang.Expert.LabelNameOrCNPJ }}:</label>
              <div class="input-group">
                <b-form-input type="text" name="txtExpertSearchName" :placeholder="$lang.Expert.PlaceholderEnterName"
                  v-model="search" :maxlength="40"></b-form-input>
              </div>
            </div>
          </div>
        </Forms>

        <Tables ref="tableGrid" :columns="[
          $lang.Expert.DataTable.Name,
          $lang.Expert.DataTable.CPF,
          $lang.Expert.DataTable.Phone,
          $lang.Expert.DataTable.Area,
          $lang.Common.DataTable.Status,
          $lang.Common.DataTable.ActionDate,
          $lang.Common.DataTable.AccountAction,
          $lang.Common.DataTable.Actions,
        ]" v-on:Load="onLoad">
          <tr v-for="obj in this.objList" v-bind:key="obj.id">
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.name"
              classCss="text-left" />
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.cpf" />
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.cellPhone" />
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.area.name" />
            <TableColumn :IsStatus="true" v-on:Edit="onEdit(obj)" :status="obj.status" />
            <TableColumn :IsDatetime="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dateUpdate" />
            <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.status"
              :value="obj.accountUserNameUpdate" />
            <TableColumn :IsActionsButtons="true" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)"
              :status="obj.status" />
          </tr>
        </Tables>
      </div>
    </slot>
  </Cfg>
</template>

<script>
import Expert from './expert.js'

export default Expert
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/expert/expert.vue